import { render, staticRenderFns } from "./ListarEscolasComFormacaoDialog.vue?vue&type=template&id=526d44da&scoped=true"
import script from "./ListarEscolasComFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./ListarEscolasComFormacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./ListarEscolasComFormacaoDialog.vue?vue&type=style&index=0&id=526d44da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526d44da",
  null
  
)

export default component.exports